import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useAcompanhamentosTab = (depotId) => {
  const history = useHistory();

  const handleCriarAcompanhamento = useCallback(() => {
    history.push(`/pages/acompanhamentos/criar?depotId=${depotId}`);
  }, [history, depotId]);
  return {
    handleCriarAcompanhamento
  };
};
